import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49d816d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "identification_title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is_checked" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-check" })
], -1))
const _hoisted_3 = { class: "info_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_localization = _resolveDirective("localization")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, null, 512), [
        [_directive_localization, 'Identification.Finish.Header']
      ]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("p", null, [
        _createTextVNode(" Когда ваша личность будет идентифицирована, вы получите уведомление"),
        _hoisted_4,
        _createTextVNode(" на электронную почту и смс. После этого вы сразу получите доступ"),
        _hoisted_5,
        _createTextVNode(" своему счёту, делать переводы и пополнять карту."),
        _hoisted_6
      ])), [
        [_directive_localization, 'Identification.Finish.Message']
      ])
    ])
  ]))
}